// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Input, Button, Toastr, Loader, Label } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Comonents Imports
import AcceptanceGraphic from "../../assets/Acceptance-Graphic.png";
// import StatusDropdown from "../QuotationTopbar/StatusDropdown";

// Internal Imports
import { GlobalUtils } from "../../utils";
import { getValidDomainUrl } from "../../actions/AuthActions/authMethods";

const { copyToClipBoard, readDataFromLocalStorage } = GlobalUtils;

class DocAcceptanceStatusUpdate extends Component {
  state = {
    btnLoader: false,
    inviteCode: "",
    buttonText: "Copy Link",
    textToCopy: "",
  };

  componentDidMount() {
    let { inviteCode } = this.state;
    if (inviteCode === "") {
      this.setState({
        btnLoader: true,
      });
      const id =
        readDataFromLocalStorage("revvsalesUser").org_id.split("-")[1] ||
        readDataFromLocalStorage("revvsalesUser").org_id;
      inviteCode = id;
      this.setState({
        inviteCode,
        textToCopy: `${getValidDomainUrl()}/referral/`,
        btnLoader: false,
      });
    }
  }

  _onClose = () => {
    this.props.toggleModalPopUp("showDocAcceptanceUpdateModal", false);
  };

  _CopyTextToClipboard = () => {
    const copiedData = copyToClipBoard(
      this.state.textToCopy + this.state.inviteCode,
    );
    if (copiedData) {
      Toastr.showToastr({
        type: "success",
        message: "Invite link copied to clipboard.",
        timeout: 3000,
      });
      this.setState({
        buttonText: "Copied",
      });
    } else {
      Toastr.showToastr({
        type: "warning",
        message:
          "Could not copy invite link. Please highlight and select link and copy to clipboard.",
        timeout: 3000,
      });
    }
  };

  render() {
    return (
      <Modal open onClose={this._onClose} closeOnOverlayClick={false} center>
        {(this.state.btnLoader || this.props.externalLoader) && (
          <Loader className="loader-bg-color" label="Please wait..." />
        )}
        <div
          className="quotationtopbar-container"
          data-test="quotationtopbar-container">
          <div className="docstatus-confirm-image">
            <div className="docstatus-confirm-text">
              <div className="docstatus-confirm-title">Awesome!</div>
              <div className="docstatus-confirm-subtitle">
                An acceptance request email has been sent to the receivers with
                a link to the document
              </div>
            </div>
            <img
              src={AcceptanceGraphic}
              alt="Revv"
              className="document-sent-confirmation-image"
            />
          </div>

          <div className="refer-and-win-amazon">
            <b>Refer & win Amazon Gift cards</b>
          </div>
          <div className="referral-text-doc-status">
            Refer 3 of your clients, consultants or peers and get an Amazon gift
            card worth $75 after they sign-up successfully. For every additional
            referral you get a $50 Amazon gift card once they sign-up.
          </div>
          <div className="form-group referral-flex-display">
            <div className="referral-popup-link-doc-staus">
              <Label htmlFor="userEmail">Here&apos;s your referral link.</Label>
              <div className="referral-popup-social">
                <Input
                  className="referral-copy-invite-text"
                  type="text"
                  readOnly="readonly"
                  value={this.state.textToCopy + this.state.inviteCode}
                  disabled="false"
                />
                <Button
                  data-test="copy-invite-code"
                  type="button"
                  className="btn btn-primary referral-copy-button"
                  onClick={this._CopyTextToClipboard}>
                  {this.state.buttonText}
                </Button>
              </div>
            </div>

            <div>
              <Label htmlFor="userEmail">Share on</Label>
              <div className="referral-popup-social">
                <a
                  className="referral-facebook"
                  data-test="facebook share"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                    this.state.textToCopy + this.state.inviteCode,
                  )}&quote=${encodeURIComponent(
                    `Gone are the days when I had to hunt for business templates and wait for days to close documents! Get your documents signed, sealed and delivered with Revv and use their stunning templates! Here’s a referral code that’ll get you a sweet discount too!
                      ${this.state.textToCopy + this.state.inviteCode}`,
                  )}`}>
                  <FontAwesomeIcon icon={["fab", "facebook"]} />
                </a>
                <a
                  className="referral-linkedin"
                  data-test="linkedin share"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                    this.state.textToCopy + this.state.inviteCode,
                  )}`}>
                  <FontAwesomeIcon icon={["fab", "linkedin"]} />
                </a>
                <a
                  className="referral-twitter"
                  data-test="twitter share"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={`https://twitter.com/share?url=${encodeURIComponent(
                    this.state.textToCopy + this.state.inviteCode,
                  )}%0A&text=${encodeURIComponent(
                    `Gone are the days when I had to hunt for business templates or wait for days to get documents signed! I use Revv for all my business paperwork and it’s a 💯. Use my link to get 💵 credits.\n`,
                  )}&via=Revv_so&hashtags=referralonrevv`}>
                  <FontAwesomeIcon icon={["fab", "twitter"]} />
                </a>
              </div>
            </div>
          </div>
          {/* <div className="change-doc-status">
            <div
              className="change-doc-statusheading"
              data-test="docstatusupdatepopup-modal-heading">
              Change document status to
            </div>
            <div className="docstatusupdate-popup-wrapper">
              <div className="doc-status-select">
                <StatusDropdown
                  currentStatus={this.props.documentStatus}
                  docId={this.props.docID}
                />
              </div>
            </div>
          </div> */}
        </div>
        <div className="docstatusupdatepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              className="btn btn-primary"
              data-test="quotationtopbar-docstatusupdate-proceed-button"
              onClick={this._onClose}>
              Done
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default DocAcceptanceStatusUpdate;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/DocAcceptanceStatusUpdate.js